import { render, staticRenderFns } from "./OrderPicker.vue?vue&type=template&id=5e3113d4&scoped=true"
import script from "./OrderPicker.vue?vue&type=script&lang=ts"
export * from "./OrderPicker.vue?vue&type=script&lang=ts"
import style0 from "./OrderPicker.vue?vue&type=style&index=0&id=5e3113d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3113d4",
  null
  
)

export default component.exports